import { render, staticRenderFns } from "./MailQueues.list.vue?vue&type=template&id=03347c1a&"
import script from "./MailQueues.list.vue?vue&type=script&lang=js&"
export * from "./MailQueues.list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports